module.exports = __webpack_public_path__ + "03_veryshort_black.cc49586c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_veryshort_black.png
// module id = /2KO
// module chunks = 0